module.exports = __webpack_public_path__ + "Banners-01-738c1148a21c9ce1fa7c.png";